// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-container {
    display: flex;
    min-height: 100vh;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.auth-sidebar {
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    color: white;
}

.sidebar-content {
    text-align: center;
    max-width: 400px;
}

.sidebar-content h1 {
    font-size: 2.5rem;
    margin-bottom: 1rem;
    font-weight: 700;
}

.sidebar-content p {
    font-size: 1.1rem;
    line-height: 1.6;
    opacity: 0.9;
}

.auth-main {
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
}

.auth-form {
    width: 100%;
    max-width: 400px;
    padding: 2rem;
}

.welcome-section {
    text-align: center;
    margin-bottom: 2rem;
}

.emoji {
    font-size: 3rem;
    display: block;
    margin-bottom: 1rem;
}

.welcome-section h2 {
    font-size: 1.8rem;
    color: #333;
    margin: 0;
}

.form-group {
    margin-bottom: 1.5rem;
}

.form-label {
    display: block;
    margin-bottom: 0.5rem;
    color: #555;
    font-weight: 500;
}

.form-input {
    width: 100%;
    padding: 0.75rem;
    border: 2px solid #e1e5e9;
    border-radius: 8px;
    font-size: 1rem;
    transition: border-color 0.3s ease;
    box-sizing: border-box;
}

.form-input:focus {
    outline: none;
    border-color: #667eea;
}

.btn {
    width: 100%;
    padding: 0.75rem;
    border: none;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
}

.btn-primary {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
}

.btn-primary:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-primary:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.loading {
    width: 20px;
    height: 20px;
    border: 2px solid transparent;
    border-top: 2px solid white;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.error-message {
    background: #fee;
    color: #c53030;
    padding: 0.75rem;
    border-radius: 8px;
    margin-top: 1rem;
    border: 1px solid #fed7d7;
}

.success-message {
    background: #f0fff4;
    color: #38a169;
    padding: 0.75rem;
    border-radius: 8px;
    margin-top: 1rem;
    border: 1px solid #c6f6d5;
}

.register-link {
    text-align: center;
    margin-top: 2rem;
    padding-top: 1rem;
    border-top: 1px solid #e1e5e9;
}

.register-link small {
    color: #666;
    display: block;
    margin-bottom: 0.5rem;
}

.register-text {
    color: #667eea;
    text-decoration: none;
    font-weight: 500;
}

.register-text:hover {
    text-decoration: underline;
}

@media (max-width: 768px) {
    .auth-container {
        flex-direction: column;
    }
    .auth-sidebar {
        padding: 1rem;
    }
    .sidebar-content h1 {
        font-size: 2rem;
    }
    .auth-form {
        padding: 1.5rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,6DAA6D;AACjE;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kCAAkC;IAClC,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,6DAA6D;IAC7D,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,2BAA2B;IAC3B,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".auth-container {\n    display: flex;\n    min-height: 100vh;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.auth-sidebar {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 2rem;\n    color: white;\n}\n\n.sidebar-content {\n    text-align: center;\n    max-width: 400px;\n}\n\n.sidebar-content h1 {\n    font-size: 2.5rem;\n    margin-bottom: 1rem;\n    font-weight: 700;\n}\n\n.sidebar-content p {\n    font-size: 1.1rem;\n    line-height: 1.6;\n    opacity: 0.9;\n}\n\n.auth-main {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: white;\n}\n\n.auth-form {\n    width: 100%;\n    max-width: 400px;\n    padding: 2rem;\n}\n\n.welcome-section {\n    text-align: center;\n    margin-bottom: 2rem;\n}\n\n.emoji {\n    font-size: 3rem;\n    display: block;\n    margin-bottom: 1rem;\n}\n\n.welcome-section h2 {\n    font-size: 1.8rem;\n    color: #333;\n    margin: 0;\n}\n\n.form-group {\n    margin-bottom: 1.5rem;\n}\n\n.form-label {\n    display: block;\n    margin-bottom: 0.5rem;\n    color: #555;\n    font-weight: 500;\n}\n\n.form-input {\n    width: 100%;\n    padding: 0.75rem;\n    border: 2px solid #e1e5e9;\n    border-radius: 8px;\n    font-size: 1rem;\n    transition: border-color 0.3s ease;\n    box-sizing: border-box;\n}\n\n.form-input:focus {\n    outline: none;\n    border-color: #667eea;\n}\n\n.btn {\n    width: 100%;\n    padding: 0.75rem;\n    border: none;\n    border-radius: 8px;\n    font-size: 1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n}\n\n.btn-primary {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.btn-primary:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n.loading {\n    width: 20px;\n    height: 20px;\n    border: 2px solid transparent;\n    border-top: 2px solid white;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.error-message {\n    background: #fee;\n    color: #c53030;\n    padding: 0.75rem;\n    border-radius: 8px;\n    margin-top: 1rem;\n    border: 1px solid #fed7d7;\n}\n\n.success-message {\n    background: #f0fff4;\n    color: #38a169;\n    padding: 0.75rem;\n    border-radius: 8px;\n    margin-top: 1rem;\n    border: 1px solid #c6f6d5;\n}\n\n.register-link {\n    text-align: center;\n    margin-top: 2rem;\n    padding-top: 1rem;\n    border-top: 1px solid #e1e5e9;\n}\n\n.register-link small {\n    color: #666;\n    display: block;\n    margin-bottom: 0.5rem;\n}\n\n.register-text {\n    color: #667eea;\n    text-decoration: none;\n    font-weight: 500;\n}\n\n.register-text:hover {\n    text-decoration: underline;\n}\n\n@media (max-width: 768px) {\n    .auth-container {\n        flex-direction: column;\n    }\n    .auth-sidebar {\n        padding: 1rem;\n    }\n    .sidebar-content h1 {\n        font-size: 2rem;\n    }\n    .auth-form {\n        padding: 1.5rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
